import { notification } from 'antd'
import apiClient from '../index'

export const getStaffList = async (params) => {
  const { skip, limit, searchedEmp } = params

  try {
    return await apiClient.get(`employee/staff/getStaffList`, {
      params: {
        skip,
        limit,
        searchedEmp,
      },
    })
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const downloadStaffList = async () => {
  try {
    return await apiClient.get(`employee/staff/downloadStaffList`)
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
